export default __webpack_public_path__ + "static/media/Rectangle 115.03fef91c.svg";